import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import config from '../config';
import FullPageSpinner from '@alphapoint/apex-web/lib/components/common/FullPageSpinner/FullPageSpinner';
import path from '@alphapoint/apex-web/lib/helpers/path';

function forVerified(WrappedComponent) {
  const ModifiedComponent = (props) => {
    const { pending, verificationLevel } = props;
    if (pending) {
      return <FullPageSpinner />;
    }
    if (verificationLevel <= config.KYC.MinimumVerificationLevel && config.KYC.UpfrontKYC) {
      return <Redirect to={path('/standalonekyc')} />;
    }

    return <WrappedComponent {...props} />;
  };

  ModifiedComponent.displayName = `forVerified(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  const mapStateToProps = (state) => ({
    verificationLevel: state.user.accounts.length ? state.user.accounts[0].VerificationLevel : 0,
    pending: !state.user.accounts.length,
  });

  return connect(mapStateToProps)(ModifiedComponent);
}

export default forVerified;
